import { extend, localize } from 'vee-validate'
import {
  min,
  required,
  email,
  confirmed,
  min_value
} from 'vee-validate/dist/rules'
import en from 'vee-validate/dist/locale/en.json'

// Install rules
extend('required', required)
extend('min', min)
extend('min_value', min_value)
extend('email', email)
extend('confirmed', confirmed)

// Custom timecode validation rule for HH:MM:SS:FF format
extend('timecode', {
  validate: value => {
    const regex = /^([0-9]{2}):([0-5][0-9]):([0-5][0-9]):([0-9]{2})$/
    return regex.test(value)
  },
  message: 'Must be in HH:MM:SS:FF format (e.g., 01:23:45:12)'
})

// Install messages
localize({ en })
